import _ from 'lodash';
import axios from "@/axios";

const state = {
  loading: false,
  getId:undefined,
  rows: [
    {id: 1, key: 'ut', val: 'نوع اول'}
  ]
};
const mutations = {
  ADD_ITEM(state, data) {
    state.rows.push(data);
  },
  INJECT(state, {rows, keys}) {
    state.rows = rows || [];
    state.keys = keys || [];
  },
  LOADING(state, data) {
    state.loading = data;
  },
  GET_ONE_BY_ID(state, data) {
    state.getId = data;
  },
  EDIT_ROW(state, data) {
    if (data.delete) {
      state.rows = _.without(state.rows, _.find(state.rows, (item) => item.val == data.row.val));
    } else {
      state.rows[data.index] = data.row;
    }
  },
};
const actions = {
  async init({commit}) {
    commit('LOADING', true);
    try {
      let res = await axios.get('config/statics');
      commit('INJECT', res.data);
    } catch (e) {

    } finally {
      commit('LOADING', false);
    }
  },
  async save({commit, state}, data) {
    commit('LOADING', true);
    try {
      if (data.id) {
        const res = await axios.put(`product/variant/${data.id}`, data);
      } else {
        const res = await axios.post('product/variant', data);
      }
    } catch (e) {
      throw e;
    } finally {
      commit('LOADING', false);
    }
  },
  async submitGroup({commit}, payload) {
    commit('LOADING', true);
    try {
      await axios.post('admin/group', {data:payload});
    } catch (e) {
      throw e;
    } finally {
      commit('LOADING', false);
    }
  },
  async editGroup({commit}, payload) {
    commit('LOADING', true);
    try {
      await axios.put('admin/group/'+payload.id,{id:payload.id,data:payload.data});
    } catch (e) {
      throw e;
    } finally {
      commit('LOADING', false);
    }
  },
  async deleteItem({commit}, id) {
    try {
       commit('LOADING', true);
       await axios.delete('admin/group/'+id)
    } catch (e) {
      throw e;
    } finally {
      commit('LOADING', false);
    }
  },
  async getOneById({commit},id) {
    try {
      commit('LOADING', true);
      const {data} = await axios.get('admin/group/' + id );
      commit('GET_ONE_BY_ID',data);
    } catch (e) {

    } finally {
      commit('LOADING', false);
    }
  }
};
const getters = {};


export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
